module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "aunote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Author’s Note:")]), _vm._v(" Where indicated with an asterisk (*), pseudonyms have been used.")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Editor’s Note:")]), _vm._v(" In the world of professional crime solving, the proper terminology is “bloodspatter.” However, for the purposes of readability in this book, the term has been broken into two separate words and appears throughout the text as “blood spatter.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccc94ad6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authors.vue
// module id = 66
// module chunks = 0